<template>
  <div class="confirmActive">
    <div class="operateClass">
      <el-button type="primary" plain @click="seeHelp">查看帮助</el-button>
    </div>
    <h3c-server-table
    :class="[
      'serverTable',
      borderShow ? 'borderShow' : ''
    ]"
    ref="tableObj"
    stripe
    :border="borderShow"
    :url="url"
    :defaultParam="defaultParam"
    :span-method="arraySpanMethod"
    :otherColumn="otherColumn"
    @currentData="currentData">
      <template 
        v-for="column in columns">
        <el-table-column
          v-if="column.show && column.prop === 'getActive'"
          :key="column.prop"
          v-bind="column">
          <template slot-scope="scope">
            <div @click="getActiveRow(scope)">
              <!-- 成功 -->
              <div class="getActiveClass" v-if="scope.row.activeResult === '0'">
                <img class="getActiveImg" src="../../../assets/img/save.svg"  alt="">
                <span class="getActiveText">获取激活信息</span>
              </div>
              <div class="getActiveClass" v-else>
                <img class="getActiveImg" src="../../../assets/img/errorTip.svg" alt="">
                <span class="getActiveText">查看失败信息</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="column.show && column.prop === 'certificateTime'"
          :key="column.prop"
          v-bind="column">
          <template slot-scope="scope">
              <div>{{ scope.row.certificateTime || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="column.show"
          :key="column.prop"
          v-bind="column"
        ></el-table-column>
      </template>
      
    </h3c-server-table>
  </div>
</template>
<script>
import h3cServerTable from "~/components/h3c-server-table.vue";
import { mapState } from "vuex";
import {activeLicense} from '~/request/configActiveLicense';
export default {
  components:{
    h3cServerTable,
  },
  data(){
    return{
      // 异步获取
      isTip: false,
      otherColumn:{
        selection: null,
        columnIndex: {
          className: 'indexColumnClass',
          width: 80
        }
      },
      borderShow: false,
      activeTableData: [],
      needMergeArr: ['activeFileName'], // 有合并项的列
      rowMergeArrs: {}, // 包含需要一个或多个合并项信息的对象
      isMerge: false,
      url: '',
      defaultParam: {},
      columns:[
        {prop: 'getActive', label: '获取激活信息', minWidth: '200', show: false},
        // {prop: 'activeFileName', label: 'activeFileName', width: '150', 'show-overflow-tooltip': true, show: true},
        {prop: 'deviceName', label: '自定义设备标识', minWidth: '230', 'show-overflow-tooltip': true, sortable: true, show: true},
        {prop: 'licenseKey', label: '授权码', minWidth: '300', 'show-overflow-tooltip': true, sortable: true, show: true},
        {prop: 'barCode', label: '软件条码', minWidth: '200', 'show-overflow-tooltip': true, sortable: true, show: true},
        {prop: 'productCode', label: '产品代码', minWidth: '110', 'show-overflow-tooltip': true, sortable: true, show: true},
        {prop: 'productDesc', label: '产品描述', minWidth: '130', 'show-overflow-tooltip': true, sortable: true, show: true},
        {prop: 'keyState', label: '授权码状态', minWidth: '110', 'show-overflow-tooltip': true, sortable: true, show: true},
        {prop: 'keyType', label: '授权码类型', minWidth: '110', 'show-overflow-tooltip': true, sortable: true, show: true},
        {prop: 'certificateTime', label: '剩余有效时限（天）', minWidth: '160', 'show-overflow-tooltip': true, sortable: true, show: true},
      ],
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.$refs.tableObj.setTableData(this.checkTableData)
    })
  },
  activated(){
    this.isTip = false;
    this.$nextTick(()=>{
      this.borderShow = false;
      this.columns[0].show = false;
      this.$refs.tableObj.setTableData(this.checkTableData)
    })
  },
  computed:{
    ...mapState(['checkTableData', 'cacheKey'])
  },
  methods:{
    currentData(currentPageData){
      this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, currentPageData);
    },
    getActiveRow({row}){
      if(row.activeResult == 1){
        // 失败
        this.$alert(`激活失败，请输入明确激活码数据或联系管理员`, '激活失败信息', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          showClose: true,
          customClass: 'alertClass'
        });
        return;
      }else{
        // 成功
        if(row.isSync === false){
          // 异步
           this.$alert(`${row.activeInfo}`, '激活结果提示', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              showClose: true,
              customClass: 'alertClass'
            });
            return;
        }else{
          // 同步
          // 0 激活码 1 下载 2 提示
          if(row.activeType == 0){
            // 提示
            this.$alert(`激活码：${row.activeInfo}`, '激活成功信息', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              showClose: true,
              customClass: 'alertClass'
            });
          }else if(row.activeType == 1){
            // 下载
            const param = {
              'activeId': row.activeId,
              'cacheKey': this.cacheKey
            };
            window.location.href = `${window.location.origin}${activeLicense.downloadActivationFile}?activeId=${param.activeId}&cacheKey=${param.cacheKey}`;
          }else if(row.activeType == 2){
            this.$alert(`${row.activeInfo}`, '激活结果提示', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              showClose: true,
              customClass: 'alertClass'
            });
          }
        }
      }
    },
    getActiveTableData(){
      if(this.isTip){
        this.$alert(`${this.activeTableData[0].activeInfo}`, '激活结果提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          showClose: true,
          customClass: 'alertClass'
        });
        // 异步情况
        return false;
      }
      return this.activeTableData;
    },
    seeHelp(){
      window.open(`${location.origin}/document/license_activation_step4.html`);
    },
    setTableData(data){
      this.activeTableData = data.slice();
      this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, data);
      this.isMerge = true;
      this.borderShow = true;
      this.columns[0].show = true;
      this.isTip = this.activeTableData.some(item => item.isSync === false);
      if(this.isTip){
        this.$alert(`${this.activeTableData[0].activeInfo}`, '激活结果提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          showClose: true,
          customClass: 'alertClass'
        });
      }
      this.$refs.tableObj.setTableData(data.slice());
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }){
      if(!this.isMerge){
        return [1, 1];
      }
      if (column.property === 'getActive'){
        return this.mergeAction('activeFileName', rowIndex, column)
      }
    },
    mergeAction(val, rowIndex, colData) {
      let _row = this.rowMergeArrs[val].rowArr[rowIndex];
      let _col = _row > 0 ? 1 : 0;
      return [_row, _col];
    },
    // 
    rowMergeHandle(arr, data) {
        if (!Array.isArray(arr) && !arr.length) return false;
        if (!Array.isArray(data) && !data.length) return false;
        let needMerge = {};
        arr.forEach(i => {
          needMerge[i] = {
            rowArr: [],
            rowMergeNum: 0
          };
          data.forEach((item, index) => {
            if (index === 0) {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = 0;
            } else {
              if (item[i] === data[index - 1][i]) {
                needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                needMerge[i].rowArr.push(0);
              } else {
                needMerge[i].rowArr.push(1);
                needMerge[i].rowMergeNum = index;
              }
            }
          });
        });
        return needMerge;
      }
  }
}
</script>
<style lang="less" scoped>
.confirmActive{
  height: 100%;
  display: flex;
  flex-direction: column;
  .operateClass{
    text-align: right;
    margin-bottom: 16px;
  }
  .serverTable{
    flex: 1;
    &.borderShow{
      /deep/ .el-table{
        border: 1px solid #ebeef5;
      }
      /deep/ .el-table__cell{
        border-bottom: 1px solid #ebeef5;
      }
    }
    /deep/ .indexColumnClass{
      padding-left: 10px !important;
    }
    .getActiveClass{
      display: flex;
      align-items: center;
      cursor: pointer;
      .getActiveImg{
        margin-right: 10px;
      }
      .getActiveText{
        border: 1px solid #E6E8EC;
        padding: 2px 10px;
        background-color: #fff;
      }
    }
  }
}
</style>